/*
 * Os textos do detalhe do voo, por prop (#4997). O genui-kit monta este objeto
 * em `flightDetailCopy(locale)`; texto com valor é função.
 */
export type FlightDetailCopy = {
  readonly title: string;
  /** O título do drawer quando o corpo é o mapa de assentos. */
  readonly seatMapTitle: string;
  readonly drawerAria: string;
  readonly backAria: string;
  /** O rodapé que escolhe o voo. */
  readonly select: string;
  readonly loading: string;
  readonly loadError: string;
  /** Quem veio pelos assentos de uma cotação vencida: o mapa acabou. */
  readonly quoteExpired: string;
  /** A nota de procedência, quando algum dado de parceiro está na tela. */
  readonly partnerDataNote: string;
  readonly dirOutbound: string;
  readonly dirReturn: string;
  readonly continuesOn: (flight: string) => string;
  readonly aircraftChange: string;
  readonly connection: (duration: string, airport: string) => string;
  readonly flightDuration: (duration: string) => string;
  readonly operatedBy: (name: string) => string;
  readonly soldAs: (flights: string) => string;
  readonly onTimeStat: (percent: string, count: string) => string;
  readonly terminal: (terminal: string) => string;
};

/** O que o enriquecimento do parceiro diz de um trecho; tudo opcional, a malha
 *  pode não cobrir o voo. */
export interface FlightEnrichmentSource {
  aircraftName?: string | undefined;
  departureTerminal?: string | undefined;
  arrivalTerminal?: string | undefined;
  onTimePercent?: number | undefined;
  onTimeObservations?: number | undefined;
  soldAs?: readonly string[] | undefined;
}

/** "Vendido também como AF 3647, KL 6106 (+2)" — no máximo 4 nomeados. */
const SOLD_AS_MAX = 4;
export function soldAsLabel(
  soldAs: readonly string[] | undefined,
  copy: Pick<FlightDetailCopy, 'soldAs'>,
): string | undefined {
  if (!soldAs || soldAs.length === 0) return undefined;
  const shown = soldAs.slice(0, SOLD_AS_MAX).join(', ');
  const rest = soldAs.length - SOLD_AS_MAX;
  return copy.soldAs(rest > 0 ? `${shown} (+${String(rest)})` : shown);
}

/** Pontualidade histórica — só com percentual E amostra presentes (amostra robusta
 *  garantida na origem; sem dado, a linha simplesmente não existe). */
export function onTimeStatLabel(
  percent: number | undefined,
  observations: number | undefined,
  copy: Pick<FlightDetailCopy, 'onTimeStat'>,
): string | undefined {
  if (percent === undefined || observations === undefined) return undefined;
  return copy.onTimeStat(String(percent), String(observations));
}

/** "Nome · Terminal 2" / só "Terminal 2" sem nome / só o nome sem terminal. */
export function withTerminal(
  name: string | undefined,
  terminal: string | undefined,
  copy: Pick<FlightDetailCopy, 'terminal'>,
): string | undefined {
  const joined = [name, terminal ? copy.terminal(terminal) : undefined].filter(Boolean).join(' · ');
  return joined || undefined;
}

/** Gate da nota de procedência — algum dado de parceiro na tela. */
export function hasEnrichmentData(e: FlightEnrichmentSource | null | undefined): boolean {
  if (!e) return false;
  return (
    e.aircraftName !== undefined ||
    e.onTimePercent !== undefined ||
    e.departureTerminal !== undefined ||
    e.arrivalTerminal !== undefined ||
    (e.soldAs !== undefined && e.soldAs.length > 0)
  );
}
